import React from 'react';
import BlogPost from '../../../../shared/components/BlogPost';
import Columns, { Column } from '../../../../shared/components/Columns';
import Heading from '../../../../shared/components/Heading';
import Stack from '../../../../shared/spa/core-components/Stack';
import { BlogPostType } from '../ContestOverviewData';

interface Props {
    blogPosts: BlogPostType;
    splitView?: boolean;
}

const BlogPosts = (blogPosts: BlogPostType) => {
    return blogPosts.map((post, index) => (
        <BlogPost
            key={index}
            thumbnailUrl={post.thumbnailUrl}
            title={post.title}
            url={post.url}
            publishedAt={post.publishedAt}
            readTimeMinutes={post.readTimeMinutes}
            horizontal
        />
    ));
};

function BlogSection({ blogPosts, splitView }: Props) {
    const halfLength = Math.ceil(blogPosts.length / 2);

    return (
        <>
            <Heading type="h3" variations={['h4']}>
                {__('We love talking design:')}
            </Heading>

            {!splitView && (
                <Stack space="space7">{BlogPosts(blogPosts.slice(0, blogPosts.length - 1))}</Stack>
            )}

            {splitView && (
                <Columns>
                    <Column width={[12, 12, 6, 6]}>
                        <Stack space="space7">{BlogPosts(blogPosts.slice(0, halfLength))}</Stack>
                    </Column>
                    <Column width={[12, 12, 6, 6]}>
                        <Stack space="space7">
                            {BlogPosts(blogPosts.slice(halfLength, blogPosts.length))}
                        </Stack>
                    </Column>
                </Columns>
            )}
        </>
    );
}

export default BlogSection;
